import { render } from "./Canvas.vue?vue&type=template&id=17c6bff2"
import script from "./Canvas.vue?vue&type=script&lang=ts"
export * from "./Canvas.vue?vue&type=script&lang=ts"
script.render = render

export default script